import React from "react"
import tw, { styled } from "twin.macro"
import GridContainer from "../page/gridContainer"
import { ReactComponent as AlertSVG } from "../../assets/alert/alert.svg"
import { ReactComponent as VerifySVG } from "../../assets/alert/verified.svg"
import { ReactComponent as CheckSVG } from "../../assets/alert/check.svg"

export interface BannerProps {
  alertTheme?: BannerTheme
  message?: string
  text: string | React.ReactNode
  action?: string
  success?: string
  isClicked?: boolean
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void
}

export enum BannerTheme {
  Alert = "alert",
  Verify = "verify",
}
export interface GetIconProps {
  alertTheme?: BannerTheme
}

const GetIcon = ({ alertTheme }: GetIconProps) => {
  switch (alertTheme) {
    case BannerTheme.Alert:
      return <AlertSVG />
    case BannerTheme.Verify:
      return <VerifySVG />
    default:
      return <></>
  }
}

const Check = styled(CheckSVG)(() => [
  tw`
    relative
    left-2
    -top-0.5
    inline-block
  `,
])

const StyledBanner = styled("section")(({ alertTheme }: GetIconProps) => [
  tw`
    py-2 bg-base-1 top-0 z-40 w-full tablet-lg:order-first
  `,
  alertTheme == BannerTheme.Alert && [tw`bg-light-red`],
  alertTheme == BannerTheme.Verify && tw`bg-light-green`,
])

export const Banner = (props: BannerProps) => {
  const { alertTheme: alertTheme, message, text, action, onClick, isClicked, success } = props
  return (
    <StyledBanner data-testid={`notify-banner-${alertTheme}`} alertTheme={alertTheme}>
      <GridContainer>
        <div tw="col-span-4 tablet:col-span-12">
          <div tw="flex flex-col space-x-0 space-y-1 tablet:(flex-row items-center min-h-[64px] space-x-3 space-y-0)">
            <div tw="tablet:pt-5 self-start">
              <GetIcon alertTheme={alertTheme} />
            </div>
            <div tw="">
              {!!message && (
                <h2 data-testid="message" tw="m-0 font-sans font-bold text-sm tablet:text-md text-base-6">
                  {message}
                </h2>
              )}
              <p data-testid="text" tw="m-0 text-sm tablet:text-md font-normal text-base-6">
                {text}
                {isClicked ? (
                  <span data-testid="success" tw="pl-1 text-green text-sm tablet:text-md font-bold inline">
                    {success}
                    <Check />
                  </span>
                ) : (
                  <button
                    data-testid={`action-${alertTheme}`}
                    tw="pl-1 text-purple text-sm tablet:text-md font-bold inline hover:underline"
                    onClick={onClick}
                    name={`action-${alertTheme}`}
                    role="button"
                  >
                    {action}
                  </button>
                )}
              </p>
            </div>
          </div>
        </div>
      </GridContainer>
    </StyledBanner>
  )
}
